export const EMAIL = 'Email is Required';
export const EMPTY = 'Should not be empty';
export const TEXT = 'Text input is Required';
export const GENERAL = 'This is general error';
export const INVALID = 'This input is not valid';
export const UNIQUE = 'Must be unique!';
export const ORDER_SELECTION_ERROR = {
  NO_ORDER_SELECTED: 'No order selected',
  NO_ORDER_AVAILABLE: 'No order available',
};
export const ERROR = '!Error';
export const PAN_NO_ERROR = 'Should contain 9 digits';
export const MOBILE_NO_DIGITS_ERROR = 'Should contain 10 digits';
